/**
 * mobile-bottom-nav.js
 * Handles cart count, cart drawer open, mobile menu toggle,
 * and collection filter trigger for the mobile bottom navigation bar.
 */
(function () {
  // Guard: prevent double-initialization if script is somehow loaded twice.
  if (window.__mbnLoaded) return;
  window.__mbnLoaded = true;

  var nav = document.getElementById('mobile-bottom-nav');
  if (!nav) return;

  // ── Cart badge ────────────────────────────────────────────────────────────

  var badge = document.getElementById('mbn-cart-badge');

  function getCartCount() {
    // Prefer xCartHelper when available (set by new-cart-helper.js).
    if (window.xCartHelper && typeof window.xCartHelper.currentItemCount === 'number') {
      return window.xCartHelper.currentItemCount;
    }
    // Fallback: read server-rendered count from the cart bubble section.
    var container = document.querySelector('#cart-icon-bubble .cart-bubble__container');
    return parseInt((container && container.dataset.countItem) || '0', 10);
  }

  function updateBadge() {
    if (!badge) return;
    var count = getCartCount();
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  // Initialize badge on load.
  updateBadge();

  // Update badge whenever the cart changes.
  document.addEventListener('maximize:cart:updated', updateBadge);

  // ── Cart button ───────────────────────────────────────────────────────────

  var cartBtn = document.getElementById('mbn-cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('cart:minicart:open'));
    });
  }

  // ── Menu button (homepage / non-collection pages) ─────────────────────────

  var menuBtn = document.getElementById('mbn-menu-btn');
  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      try {
        // Alpine and the xMobileNav store are defined by header.js (defer).
        // By the time this click fires, Alpine is always initialized.
        if (typeof Alpine !== 'undefined' && Alpine.store) {
          Alpine.store('xMobileNav').toggle();
        }
      } catch (e) {
        // Silently ignore if Alpine store is unavailable.
      }
    });
  }

  // ── Categories button (collection pages) ─────────────────────────────────

  var categoriesBtn = document.getElementById('mbn-categories-btn');
  if (categoriesBtn) {
    categoriesBtn.addEventListener('click', function () {
      // #btn-filter is rendered by snippets/facets.liquid on all collection pages.
      // Clicking it triggers the existing Alpine filter logic in the correct scope.
      var filterBtn = document.getElementById('btn-filter');
      if (filterBtn) {
        filterBtn.click();
      }
    });
  }

  // ── Body class (drives padding-bottom via CSS) ────────────────────────────

  function syncBodyClass() {
    // lg breakpoint in this theme = 1024px (MIN_DEVICE_WIDTH.desktop in constants.js).
    if (window.innerWidth < 1024) {
      document.body.classList.add('has-mobile-bottom-nav');
    } else {
      document.body.classList.remove('has-mobile-bottom-nav');
    }
  }

  // Set immediately and on resize.
  syncBodyClass();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncBodyClass, 100);
  });
})();
